import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CollapseButtonComponent } from '@design/collapse-button/components/collapse-button/collapse-button.component';
import { LeftNavigationComponent } from '@layout/navigation/components/left-navigation/left-navigation.component';
import { ManagersButtonComponent } from '@layout/left-panel/components/managers-button/managers-button.component';
import { AccountTeamPanelComponent } from '@layout/account-team/components/account-team-panel/account-team-panel.component';
import { Permission } from '@kaseya-shared';

import { MenuSettingsFacade } from '@layout/left-panel/facades/menu-settings.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { PermissionDirective } from '@core/permissions/directives/permission.directive';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

@Component({
  selector: 'itc-left-panel',
  templateUrl: 'left-panel.component.html',
  styleUrl: 'left-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CollapseButtonComponent,
    LeftNavigationComponent,
    ManagersButtonComponent,
    AccountTeamPanelComponent,
    PermissionDirective,
    TranslatePipe,
  ],
})
export class LeftPanelComponent {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly menuSettingsFacade = inject(MenuSettingsFacade);
  private readonly permissionsFacade = inject(PermissionsFacade);

  readonly Permission = Permission;
  readonly isLeftPanelCollapsed = this.menuSettingsFacade.isMenuCollapsed;
  readonly hasAccessToMenuSettingsModify = this.permissionsFacade.hasPermission(Permission.MenuSettingsModify);
  readonly hasAccessToMenuSettingsView = this.permissionsFacade.hasPermission(Permission.MenuSettingsView);

  get isMigratedUser(): boolean {
    return this.authorizationService.isMigratedUser();
  }

  constructor() {
    this.loadMenuSettingsWhenPermitted();
  }

  updateMenuSettings(): void {
    if (this.hasAccessToMenuSettingsModify()) {
      this.menuSettingsFacade.updateMenuSettings(!this.isLeftPanelCollapsed());
    }
  }

  private loadMenuSettingsWhenPermitted(): void {
    effect(() => {
      if (this.hasAccessToMenuSettingsView()) {
        this.menuSettingsFacade.loadMenuSettings();
      }
    });
  }
}
